<div class="p-4 sm:p-6 bg-slate-50 min-h-screen">
  <!-- Header -->
  <div class="mb-6">
  <h2 class="text-2xl font-semibold text-slate-800 relative pl-3">
    <span class="absolute left-0 top-1 w-1 h-6 bg-indigo-600 rounded"></span>
    Udhar Report
  </h2>
  <p class="text-sm text-slate-500 mt-1 pl-3">
    Pending customer balances
  </p>
</div>
  <!-- Summary Cards -->
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
    <!-- Total Udhar -->
    <div class="bg-white border border-slate-200 rounded-xl p-4 shadow-sm">
      <p class="text-sm text-slate-500">Total Udhar</p>
      <p class="text-2xl font-semibold text-amber-600 mt-1">
        ₹ {{ totalUdhar | number : "1.2-2" }}
      </p>
    </div>

    <!-- Total Invoices -->
    <div class="bg-white border border-slate-200 rounded-xl p-4 shadow-sm">
      <p class="text-sm text-slate-500">Pending Invoices</p>
      <p class="text-2xl font-semibold text-indigo-600 mt-1">
        {{ udharList.length }}
      </p>
    </div>

    <!-- Total Paid -->
    <div class="bg-white border border-slate-200 rounded-xl p-4 shadow-sm">
      <p class="text-sm text-slate-500">Total Paid</p>
      <p class="text-2xl font-semibold text-emerald-600 mt-1">
        ₹ {{ totalPaid | number : "1.2-2" }}
      </p>
    </div>

    <!-- Customers -->
    <div class="bg-white border border-slate-200 rounded-xl p-4 shadow-sm">
      <p class="text-sm text-slate-500">Unique Customers</p>
      <p class="text-2xl font-semibold text-slate-700 mt-1">
        {{ uniqueCustomers }}
      </p>
    </div>
  </div>

  <!-- Search & Summary -->
  <!-- Search & Export Toolbar -->
  <div class="bg-white rounded-xl shadow-sm border border-slate-200 mb-6">
    <div
      class="p-4 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4"
    >
      <!-- Search Box -->
      <div class="relative w-full lg:w-96">
        <span
          class="absolute inset-y-0 left-0 flex items-center pl-3 text-slate-400"
        >
          🔍
        </span>
        <input
          type="text"
          [(ngModel)]="searchText"
          (input)="filterTable()"
          placeholder="Search invoice, customer, mobile..."
          class="w-full pl-10 pr-4 py-2.5 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none"
        />
      </div>

      <!-- Export Buttons -->
      <div class="flex flex-wrap gap-2 justify-start lg:justify-end">
        <button
          (click)="downloadPDF()"
          class="px-4 py-2 rounded-lg bg-red-600 text-white text-sm font-medium hover:bg-red-700"
        >
          PDF
        </button>

        <button
          (click)="downloadExcel()"
          class="px-4 py-2 rounded-lg bg-emerald-600 text-white text-sm font-medium hover:bg-emerald-700"
        >
          Excel
        </button>

        <button
          (click)="downloadCSV()"
          class="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700"
        >
          CSV
        </button>

        <button
          (click)="downloadJSON()"
          class="px-4 py-2 rounded-lg bg-slate-700 text-white text-sm font-medium hover:bg-slate-800"
        >
          JSON
        </button>
      </div>
    </div>

    <!-- Record Count -->
    <div class="px-4 pb-3 text-sm text-slate-600">
      Total Records:
      <span
        class="ml-1 px-2 py-0.5 rounded-md bg-indigo-50 text-indigo-600 font-semibold"
      >
        {{ udharList.length }}
      </span>
    </div>
  </div>

  <!-- Table -->
  <div
    class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-x-auto"
  >
    <table class="min-w-full text-sm">
      <thead class="bg-slate-100 text-slate-700 sticky top-0 z-10">
        <tr>
          <th
            *ngFor="let col of columns"
            (click)="sortBy(col.key)"
            class="px-4 py-3 text-left font-semibold cursor-pointer whitespace-nowrap"
          >
            {{ col.label }}
            <span class="ml-1 text-xs text-slate-400">⇅</span>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="let item of paginatedList"
          class="hover:bg-indigo-50 transition"
        >
          <td
            *ngFor="let col of columns"
            class="px-4 py-3 border-t border-slate-200 whitespace-nowrap"
            [ngClass]="{
              'text-amber-600 font-semibold': col.key === 'balance_due'
            }"
          >
            {{ getValue(item, col.key) }}
          </td>
        </tr>

        <!-- No Data -->
        <tr *ngIf="paginatedList.length === 0">
          <td
            [attr.colspan]="columns.length"
            class="text-center py-8 text-slate-500"
          >
            No udhar records found
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div class="flex justify-center sm:justify-end mt-6 gap-2 flex-wrap">
    <button
      *ngFor="let p of [].constructor(totalPages); let i = index"
      (click)="goToPage(i + 1)"
      class="px-3 py-1.5 rounded-lg border text-sm transition"
      [ngClass]="{
        'bg-indigo-600 text-white border-indigo-600 shadow-sm':
          currentPage === i + 1,
        'bg-white border-slate-300 text-slate-700 hover:bg-slate-100':
          currentPage !== i + 1
      }"
    >
      {{ i + 1 }}
    </button>
  </div>
</div>
